import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MaterialButton from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';

import { onClickWrapper } from '../../../utils/ui';

import styles from './index.module.scss';

const Button = ({
  onClick,
  type,
  children,
  className,
  variant,
  fullWidth,
  disabled,
  id,
  disableElevation
}) => {
  const classes = {
    root: classNames(
      styles['button'],
      variant === 'text' ? styles['button-text'] : '',
      className
    )
  };

  return variant !== 'fab' ? (
    variant !== 'icon' ? (
      <MaterialButton
        {...{ type, classes, fullWidth, disabled, id }}
        variant={variant || 'contained'}
        onClick={onClickWrapper(id, onClick)}
        disabled={disabled} // add for calculator
        disableElevation={disableElevation}
      >
        {children}
      </MaterialButton>
    ) : (
      <IconButton
        {...{ type, classes, disabled, id }}
        onClick={onClickWrapper(id, onClick)}
      >
        {children}
      </IconButton>
    )
  ) : (
    <Fab
      {...{ type, classes, disabled, id }}
      onClick={onClickWrapper(id, onClick)}
    >
      {children}
    </Fab>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.string,
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool
};

export default Button;
